import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { getMonthName } from '../helpers/get-month-name';
import { DashboardService } from '../services/dashboard.service';
import { CommonUtil } from '../../core/Utils/common-util';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';

@Component({
  selector: 'app-calendar-dashboard',
  templateUrl: './calendar-dashboard.component.html',
  styleUrls: ['./calendar-dashboard.component.css'],
})
export class CalendarDashboardComponent implements OnInit, OnDestroy {
  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;
  todaysDate = new Date();
  currentMonth: any;
  currentYear: any;
  currentDate: any;
  getCurrentMonthName: any;
  displayCalendar: any;
  currentTimestamp: any;
  popupTask: any;
  showPopup1 = false;
  showPopup2 = false;
  popupIndex: string;
  xPosition: any;
  yPosition: any;
  calendarPopupdataClass: HTMLCollectionOf<Element>;
  calendarUrlSchedule: any;
  calendarUrl: any;
  rowCounter: any;
  currentFacility: FacilityObject;

  // subscriptions
  private _facilityOnChange:any;

  constructor(
    private rootScopeService: RootScopeService,
    private dashboardService: DashboardService,
    private commonUtil: CommonUtil,
    private _facilityService: FacilityService
  ) {}

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;
    });
  }

  ngOnInit() {
    this.getRootScopeData();
    this.cloudBasePath = environment.cloudBasePath;
    this.currentMonth = this.todaysDate.getMonth();
    this.getCurrentMonthName = getMonthName[this.currentMonth].month;
    this.currentYear = this.todaysDate.getFullYear();
    this.currentDate = this.todaysDate.getDate();

    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
      this.generateCalendarData();
    });

    if (this.currentFacility['facilityId']) {
      this.generateCalendarData();
    }
  }

  ngOnDestroy() {
    // distryo subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  generateCalendarData() {
    this.dashboardService
      .getCalendarData(
        this.currentFacility.facilityId,
        this.currentFacility.summary.timezone
      )
      .subscribe(
        data => {
          this.displayCalendar = data.calendarData;
          this.displaydataincalendar(this.displayCalendar);
          this.calendarUrlSchedule = data.calendarUrlSchedule;
          this.calendarUrl = data.calendarUrl;
        },
        error => {
          console.error('API failed.');
        }
      );
  }
  displayCalendarDate(currentDay:any) {
    if (isNaN(currentDay)) {
      const splitstring = currentDay.split(' ');
      const data1 = splitstring[0];
      const data2 = splitstring[1];
      return this.commonUtil.translateText(data1) + ' ' + data2;
    } else {
      return currentDay;
    }
  }
  displaydataincalendar(displayCalendar:any) {
    if(!displayCalendar || displayCalendar.length < 1) return;
    let i;
    for (i = 0; i < 14; i++) {
      if (displayCalendar[i].today === 'true') {
        this.currentTimestamp = displayCalendar[i].millis;
        break;
      }
    }
  }

  openDetails(task: any, index: string, rowValue: string, count: any) {
    this.rowCounter = count;
    this.popupTask = task;
    this.popupIndex = index;
    if (rowValue === 'row1') {
      this.showPopup1 = true;
      this.showPopup2 = false;
    } else if (rowValue === 'row2') {
      this.showPopup2 = true;
      this.showPopup1 = false;
    }
    let previousIndex: string;
    let calendarPopupdata: any;
    let prevIndexGetElement:any;


    setTimeout(function() {
      if (previousIndex !== undefined) {
        prevIndexGetElement=<HTMLElement>document.getElementById('calendarPopupDataId' + previousIndex);
        prevIndexGetElement.style.display = 'none';
      }
      previousIndex = index;
      calendarPopupdata = <HTMLElement>document.getElementById('calendarPopupDataId' + index);
      calendarPopupdata.style.display = 'block';
    }, 100);
  }
  getEquipmentNameByTypeId(activityId: string) {
    if (activityId === '203') {
      return this.commonUtil.translateText('LIFECYCLE.EXERCISE.BIKE');
    } else if (activityId === '2') {
      return this.commonUtil.translateText('UPRIGHT.BIKE');
    } else if (activityId === '3') {
      return this.commonUtil.translateText('RECUMBENT.BIKE');
    } else if (activityId === '1') {
      return this.commonUtil.translateText('TREADMILL');
    } else if (activityId === '15') {
      return this.commonUtil.translateText('FLEXSTRIDER.VARIABLE.STRIDE.TRAINER');
    } else if (activityId === '16') {
      return this.commonUtil.translateText('POWERMILL.CLIMBER');
    } else if (activityId === '4') {
      return this.commonUtil.translateText('ELLIPTICAL.CROSS.TRAINER');
    } else if (activityId === '18') {
      return this.commonUtil.translateText('GSC.TRAINER');
    } else if (activityId === '19') {
      return this.commonUtil.translateText('ARC.TRAINER');
    }
  }
  closeDetails() {
    this.showPopup1 = false;
    this.showPopup2 = false;
  }
  redirectToServicePage(redirectTo:string) {
    if (redirectTo === 'view') {
      localStorage.setItem('maintenanceUrl', this.calendarUrl);
    } else if (redirectTo === 'schedule') {
      localStorage.setItem('maintenanceUrl', this.calendarUrlSchedule);
    }
  }
}
